import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { ProductListingListComponent } from './product-listing-list/product-listing-list.component';
import { ProductListingFormComponent } from './product-listing-form/product-listing-form.component';

const routes: Routes = [
  { path: '', component: ProductListingListComponent },
  { path: ':mode', component: ProductListingFormComponent }
]
@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class ProductListingRoutingModule { }
